/**
 * Emission factor data types
 * @type {{ChemicalsHazardousSubstances: {label: string, value: string}, Water: {label: string, value: string}, ManufacturingProcesses: {label: string, value: string}, HotelStays: {label: string, value: string}, Products: {label: string, value: string}, TransportSea: {label: string, value: string}, TransportAir: {label: string, value: string}, CombustionOther: {label: string, value: string}, Materials: {label: string, value: string}, DirectEmissions: {label: string, value: string}, CapitalGoods: {label: string, value: string}, TransportRail: {label: string, value: string}, Waste: {label: string, value: string}, CombustionStationary: {label: string, value: string}, Energy: {label: string, value: string}, CombustionMobile: {label: string, value: string}, Fugitives: {label: string, value: string}, TransportRoad: {label: string, value: string}, EquipmentAndMachinery: {label: string, value: string}, Food: {label: string, value: string}, Other: {label: string, value: string}}}
 */
export const EMISSION_FACTOR_DATASETS = {
  CapitalGoods: {
    value: "capital_goods",
    label: "Capital Goods",
  },
  ChemicalsHazardousSubstances: {
    value: "chemicals_hazardous_substances",
    label: "Chemicals / Hazardous substances",
  },
  CombustionOther: {
    value: "combustion_other",
    label: "Combustion (Other)",
  },
  CombustionMobile: {
    value: "combustion_mobile",
    label: "Combustion (Mobile)",
  },
  CombustionStationary: {
    value: "combustion_stationary",
    label: "Combustion (Stationary)",
  },
  DirectEmissions: {
    value: "direct_emissions",
    label: "Direct emissions",
  },
  Energy: {
    value: "energy",
    label: "Energy",
  },
  EquipmentAndMachinery: {
    value: "equipment_and_machinery",
    label: "Equipment and machinery",
  },
  Food: {
    value: "food",
    label: "Food",
  },
  Fugitives: {
    value: "fugitives",
    label: "Fugitives",
  },
  HotelStays: {
    value: "hotel_stays",
    label: "Hotel stays",
  },
  ManufacturingProcesses: {
    value: "manufacturing_processes",
    label: "Manufacturing processes",
  },
  Materials: {
    value: "materials",
    label: "Materials",
  },
  Other: {
    value: "other",
    label: "Other",
  },
  Products: {
    value: "products",
    label: "Products",
  },
  TransportAir: {
    value: "transport_air",
    label: "Transport (Air)",
  },
  TransportRail: {
    value: "transport_rail",
    label: "Transport (Rail)",
  },
  TransportRoad: {
    value: "transport_road",
    label: "Transport (Road)",
  },
  TransportSea: {
    value: "transport_sea",
    label: "Transport (Sea)",
  },
  Waste: {
    value: "waste",
    label: "Waste",
  },
  Water: {
    value: "water",
    label: "Water",
  },
};
